import { getResData, httpClient } from "utils";
import type {
  CreateOrUpdateEmissionTargetRequest,
  EmissionTarget,
} from "./types";

const EMISSION_TARGETS_BASE = "/emission-targets";

export const EMISSION_TARGETS_API_PATHS = {
  LIST: EMISSION_TARGETS_BASE,
  BY_ID: (id: number) => `${EMISSION_TARGETS_BASE}/${id}`,
};

/** GET /emission-targets */
export const getEmissionTargets = (): Promise<EmissionTarget[]> =>
  httpClient
    .get<EmissionTarget[]>(EMISSION_TARGETS_API_PATHS.LIST)
    .then(getResData);

/** POST /emission-targets */
export const createEmissionTarget = (
  body: CreateOrUpdateEmissionTargetRequest
): Promise<EmissionTarget> =>
  httpClient
    .post<EmissionTarget>(EMISSION_TARGETS_API_PATHS.LIST, body)
    .then(getResData);

/** PUT /emission-targets/{id} */
export const updateEmissionTarget = (
  id: number,
  body: CreateOrUpdateEmissionTargetRequest
): Promise<EmissionTarget> =>
  httpClient
    .put<EmissionTarget>(EMISSION_TARGETS_API_PATHS.BY_ID(id), body)
    .then(getResData);

/** DELETE /emission-targets/{id} */
export const deleteEmissionTarget = (id: number): Promise<void> =>
  httpClient.delete(EMISSION_TARGETS_API_PATHS.BY_ID(id));
